export default __webpack_public_path__ + "static/media/Icon-med-Netzwerke.2c34870c.svg";